/* eslint-disable react/jsx-newline */

import * as React from "react";

export const AdCopyGroupPanel = React.memo((props: { label: string; value: string }) => {
	const { label, value } = props;

	return (
		<div>
			・{label}：{value}{" "}
		</div>
	);
});

export const AdCopySCategoryRow = React.memo((props: { label: string; value: string }) => {
	const { label, value } = props;

	return (
		<div>
			・{label}：{value}{" "}
		</div>
	);
});
